import { render, staticRenderFns } from "./soundCard.vue?vue&type=template&id=1831c616&scoped=true&"
import script from "./soundCard.vue?vue&type=script&lang=js&"
export * from "./soundCard.vue?vue&type=script&lang=js&"
import style0 from "./soundCard.vue?vue&type=style&index=0&id=1831c616&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1831c616",
  null
  
)

export default component.exports